import { createContext } from 'react';
import { initialState } from 'components/Booking-new/reducers';

const BookingContext = createContext({
  state: initialState,
  dispatch: () => null,
});

export default BookingContext;
